function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "x", "y"],
  _excluded2 = ["x", "y", "shape", "msg", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import olSourceVector from 'ol/source/Vector';
import olLayerVector from 'ol/layer/Vector';
import olFeature from 'ol/Feature';
import * as olGeom from 'ol/geom';
import '../../request/AddMarkerRequest';
import '../../request/AddMarkerRequestHandler';
import '../../request/RemoveMarkersRequest';
import '../../request/RemoveMarkersRequestHandler';
import '../../request/MarkerVisibilityRequest';
import '../../request/MarkerVisibilityRequestHandler';
import '../../event/AfterAddMarkerEvent';
import '../../event/MarkerClickEvent';
import '../../event/AfterRemoveMarkersEvent';
import { showAddMarkerPopup } from './view/MarkersForm';
import { showMarkerPopup } from './view/MarkerPopup';
import { ID_PREFIX, PLUGIN_NAME, TOOL_GROUP, DEFAULT_STYLE, GEOMETRY_TYPE, DEFAULT_DATA, SEPARATORS } from './constants';

/**
 * @class Oskari.mapframework.mapmodule.MarkersPlugin
 * Provides marker functionality for the map.
 */
Oskari.clazz.define('Oskari.mapframework.mapmodule.MarkersPlugin',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  var _this = this;
  this._clazz = 'Oskari.mapframework.mapmodule.MarkersPlugin';
  this._name = PLUGIN_NAME;
  this._hiddenMarkers = {}; // id: olFeature
  this._styleData = {}; // store values as it's hard to get them from feature's ol style

  this.buttons = null;
  this.markerPopupControls = null;
  this._buttonsAdded = false;
  this._showAddMarkerPopupOnMapClick = false;

  // Show the marker button
  this._layer = undefined;
  this.log = Oskari.log(PLUGIN_NAME);
  this.popupControls = null;
  this.popupCleanup = function () {
    var restartTool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (_this.popupControls) {
      _this.popupControls.close();
      _this._showAddMarkerPopupOnMapClick = true;
    }
    _this.popupControls = null;
    if (!_this.markerPopupControls && restartTool) {
      _this.startMarkerAdd();
    }
  };
}, {
  /**
   * @method hasUI
   * @return {Boolean} true
   * This plugin has an UI so always returns true
   */
  hasUI: function hasUI() {
    return true;
  },
  _createEventHandlers: function _createEventHandlers() {
    var _this2 = this;
    return {
      MapClickedEvent: function MapClickedEvent(event) {
        return _this2._mapClick(event);
      },
      'Toolbar.ToolbarLoadedEvent': function ToolbarToolbarLoadedEvent() {
        return _this2._registerTools();
      },
      'Toolbar.ToolSelectedEvent': function ToolbarToolSelectedEvent(event) {
        if (event.getToolId() !== 'addMarker' && event.getSticky()) {
          if (_this2.popupControls) {
            _this2.popupCleanup(false);
          }
          _this2.stopMarkerAdd(false);
        }
      }
    };
  },
  _createRequestHandlers: function _createRequestHandlers() {
    var me = this;
    var sandbox = me.getSandbox();
    return {
      'MapModulePlugin.AddMarkerRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.AddMarkerRequestHandler', sandbox, me),
      'MapModulePlugin.RemoveMarkersRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.RemoveMarkersRequestHandler', sandbox, me),
      'MapModulePlugin.MarkerVisibilityRequest': Oskari.clazz.create('Oskari.mapframework.bundle.mapmodule.request.MarkerVisibilityRequestHandler', sandbox, me)
    };
  },
  /**
   * @method register
   * Interface method for the plugin protocol
   */
  register: function register() {
    this.getMapModule().setLayerPlugin('markers', this);
  },
  /**
   * @method unregister
   * Interface method for the plugin protocol
   */
  unregister: function unregister() {
    this.getMapModule().setLayerPlugin('markers', null);
  },
  /**
   * @private @method _startPluginImpl
   * Interface method for the plugin protocol.
   * Creates the base marker layer.
   */
  _startPluginImpl: function _startPluginImpl() {
    var _this3 = this;
    this.buttons = {
      addMarker: {
        iconCls: 'marker-share',
        tooltip: this.getMsg('tooltip'),
        sticky: true,
        callback: function callback() {
          return _this3.startMarkerAdd();
        }
      }
    };
    // Register marker tools
    this._registerTools();
  },
  /**
   * Requests the tools to be added to the toolbar.
   *
   * @method registerTool
   */
  _registerTools: function _registerTools() {
    var _this4 = this;
    var _this$getConfig = this.getConfig(),
      markerButton = _this$getConfig.markerButton;
    if (this._buttonsAdded || markerButton === false) {
      return;
    }
    var sandbox = this.getSandbox();
    if (!sandbox.hasHandler('Toolbar.AddToolButtonRequest')) {
      // Couldn't get the request, toolbar not loaded
      return;
    }
    var reqBuilder = Oskari.requestBuilder('Toolbar.AddToolButtonRequest');
    Object.keys(this.buttons).forEach(function (btnName) {
      var request = reqBuilder(btnName, TOOL_GROUP, _this4.buttons[btnName]);
      sandbox.request(_this4.getName(), request);
    });
    this._buttonsAdded = true;
  },
  /**
   * Handles generic map click
   * @private
   * @param  {Oskari.mapframework.bundle.mapmodule.event.MapClickedEvent} event map click
   */
  _mapClick: function () {
    var _mapClick2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var _this5 = this;
      var _pixels, pixels, features, _iterator, _step, feature, _event$getLonLat, lon, lat, onAdd, onDelete, markerData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.keepToolActive = true;
            if (this.markerPopupControls) {
              this.closeMarkerPopup();
            }
            this.keepToolActive = false;
            if (this._showAddMarkerPopupOnMapClick) {
              _context.next = 7;
              break;
            }
            // get markers from layer by pixel so we get result based on visualization and not the coordinate for the point
            _pixels = [event.getMouseX(), event.getMouseY()];
            this.getMarkersLayer().getFeatures(_pixels).then(function (featureList) {
              return featureList.forEach(function (feature) {
                return _this5._markerClicked(feature.getId());
              });
            });
            return _context.abrupt("return");
          case 7:
            // get markers from layer by pixel so we get result based on visualization and not the coordinate for the point
            pixels = [event.getMouseX(), event.getMouseY()];
            _context.next = 10;
            return this.getMarkersLayer().getFeatures(pixels);
          case 10:
            features = _context.sent;
            _iterator = _createForOfIteratorHelper(features);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                feature = _step.value;
                this._markerClicked(feature.getId());
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            if (this._showAddMarkerPopupOnMapClick) {
              _context.next = 15;
              break;
            }
            return _context.abrupt("return");
          case 15:
            // adding a marker
            _event$getLonLat = event.getLonLat(), lon = _event$getLonLat.lon, lat = _event$getLonLat.lat;
            this._showAddMarkerPopupOnMapClick = false;
            onAdd = function onAdd(style, marker) {
              var coord = marker ? [marker.x, marker.y] : [lon, lat];
              _this5.popupCleanup();
              _this5._addMarkerFromPopup(coord, style, marker === null || marker === void 0 ? void 0 : marker.id);
            };
            onDelete = function onDelete(marker) {
              _this5.popupCleanup();
              _this5.removeMarkers(marker.id);
            };
            if (features.length > 0) {
              markerData = this._featureToMarkerData(features[0]);
              this.popupControls = showAddMarkerPopup(onAdd, onDelete, this.popupCleanup, markerData);
            } else {
              this.popupControls = showAddMarkerPopup(onAdd, onDelete, this.popupCleanup);
            }
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function _mapClick(_x) {
      return _mapClick2.apply(this, arguments);
    }
    return _mapClick;
  }(),
  /**
   * Called when a marker has been clicked.
   * @method  _markerClicked
   * @private
   * @param  {String} markerId which was clicked
   */
  _markerClicked: function _markerClicked(markerId) {
    var clickEvent = Oskari.eventBuilder('MarkerClickEvent')(markerId);
    this.getSandbox().notifyAll(clickEvent);
  },
  getMarkersLayer: function getMarkersLayer() {
    if (!this._layer) {
      this._layer = new olLayerVector({
        title: 'Markers',
        source: new olSourceVector()
      });
      this.getMapModule().addOverlayLayer(this._layer, 'markers');
    }
    return this._layer;
  },
  getOLMapLayers: function getOLMapLayers() {
    return [];
  },
  getMapMarkerBounds: function getMapMarkerBounds() {
    return this.getMarkersLayer().getSource().getExtent();
  },
  closeMarkerPopup: function closeMarkerPopup() {
    if (this.markerPopupControls) {
      this.markerPopupControls.close();
    }
    this.markerPopupControls = null;
    if (!this.keepToolActive) {
      this.stopMarkerAdd();
    }
  },
  /**
   * Activate the "add marker mode" on map.
   */
  startMarkerAdd: function startMarkerAdd() {
    var _this6 = this;
    if (Oskari.util.isMobile()) {
      Oskari.dom.showNavigation(false);
    }
    this.enableGfi(false);
    this._showAddMarkerPopupOnMapClick = true;
    if (!this.markerPopupControls) {
      this.markerPopupControls = showMarkerPopup(function () {
        return _this6.removeMarkers();
      }, function () {
        return _this6.closeMarkerPopup();
      });
    }
    this.getMapModule().setCursorStyle('crosshair');
  },
  /**
   * Stops the marker location selector
   */
  stopMarkerAdd: function stopMarkerAdd() {
    var selectDefault = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this.enableGfi(true);
    this._showAddMarkerPopupOnMapClick = false;
    if (this.markerPopupControls) {
      this.closeMarkerPopup();
    }
    if (this.popupControls) {
      this.popupCleanup();
    }
    this.getMapModule().setCursorStyle('');
    if (!selectDefault) {
      return;
    }
    // ask toolbar to select default tool if available
    var toolbarRequest = Oskari.requestBuilder('Toolbar.SelectToolButtonRequest');
    if (toolbarRequest) {
      this.getSandbox().request(this, toolbarRequest());
    }
  },
  addMapMarker: function addMapMarker(markerData, markerId) {
    // Combine default values with given values
    var _this$_getSanitizedMa = this._getSanitizedMarker(markerData, markerId),
      id = _this$_getSanitizedMa.id,
      x = _this$_getSanitizedMa.x,
      y = _this$_getSanitizedMa.y,
      styleData = _objectWithoutProperties(_this$_getSanitizedMa, _excluded);
    if (!id) {
      // validation failed
      this.log.warn('Error while adding marker');
      return;
    }
    this._styleData[id] = styleData;
    var style = this._getStyleFromMarkerData(styleData);
    this._addMarkerToMap(id, [x, y], style);
  },
  removeMarkers: function removeMarkers(id) {
    if (id) {
      delete this._hiddenMarkers[id];
      delete this._styleData[id];
      this._removeMarkerFromMap(id);
    } else {
      // remove all
      this.getMarkersLayer().getSource().clear();
      this._hiddenMarkers = {};
      this._styleData = {};
    }
    var removeEvent = Oskari.eventBuilder('AfterRemoveMarkersEvent')(id);
    this.getSandbox().notifyAll(removeEvent);
  },
  _getSanitizedMarker: function _getSanitizedMarker(markerData, markerId) {
    var x = markerData.x,
      y = markerData.y,
      shape = markerData.shape,
      msg = markerData.msg,
      color = markerData.color,
      other = _objectWithoutProperties(markerData, _excluded2);
    // Validation: coordinates are needed
    if (typeof x === 'undefined' || typeof y === 'undefined') {
      this.log.warn('Undefined coordinate in', markerData);
      return {};
    }
    // generate id if not provided
    var id = markerId || ID_PREFIX + Oskari.getSeq(this.getName()).nextVal();
    var sanitized = _objectSpread({
      id: id,
      x: x,
      y: y
    }, DEFAULT_DATA);
    if (typeof shape !== 'undefined') {
      sanitized.shape = isNaN(shape) ? shape : parseInt(shape);
    }
    if (msg) {
      sanitized.msg = decodeURIComponent(msg);
    }
    if (color) {
      sanitized.color = color.charAt(0) === '#' ? color.substring(1) : color;
    }
    Object.keys(other).forEach(function (key) {
      var value = other[key];
      if (typeof value !== 'undefined') {
        sanitized[key] = value;
      }
    });
    return sanitized;
  },
  /**
   * Close enough "backwards compatibility" workaround for marker size when using external graphic/svg as icon.
   * If the requested size is below 10 -> use the formula used pre-2.7 to calculate size.
   * Otherwise keep the requested size (documented as pixel size).
   * @param {Number} requestedSize pixel value or previously supported value of 1-5 like for built-in symbols. Cut off point for logic is at 10.
   */
  __workaroundForBackwardsCompatibilitySize: function __workaroundForBackwardsCompatibilitySize(requestedSize) {
    if (typeof requestedSize === 'number' && requestedSize < 10) {
      var mapmodule = this.getMapModule();
      if (mapmodule && typeof mapmodule.getPixelForSize === 'function') {
        return mapmodule.getPixelForSize(requestedSize);
      }
    }
    return requestedSize;
  },
  _getStyleFromMarkerData: function _getStyleFromMarkerData(markerData) {
    var style = jQuery.extend(true, {}, DEFAULT_STYLE);
    var color = markerData.color,
      shape = markerData.shape,
      size = markerData.size,
      msg = markerData.msg,
      offsetX = markerData.offsetX,
      offsetY = markerData.offsetY;
    style.image.fill.color = '#' + color;
    style.image.shape = shape;
    style.text.labelText = msg;
    // use pixel size if shape is svg or url
    if (typeof shape === 'string') {
      style.image.sizePx = this.__workaroundForBackwardsCompatibilitySize(size);
    } else {
      style.image.size = size;
    }
    if (typeof offsetX !== 'undefined') {
      style.image.offsetX = offsetX;
    }
    if (typeof offsetY !== 'undefined') {
      style.image.offsetY = offsetY;
    }
    return style;
  },
  _addMarkerFromPopup: function _addMarkerFromPopup(coord, style, existingId) {
    var id = existingId || ID_PREFIX + Oskari.getSeq(this.getName()).nextVal();
    var image = style.image,
      text = style.text;
    var fill = image.fill,
      shape = image.shape,
      size = image.size;
    var styleData = {
      color: fill.color.substring(1),
      shape: shape,
      size: size,
      msg: text.labelText
    };
    this._styleData[id] = styleData;
    this._addMarkerToMap(id, coord, style);
  },
  _addMarkerToMap: function _addMarkerToMap(id, coord, style) {
    var layerSource = this.getMarkersLayer().getSource();
    var olStyle = this.getMapModule().getStyle(style, GEOMETRY_TYPE);
    var feature = new olFeature(new olGeom.Point(coord));
    feature.setId(id);
    feature.setStyle(olStyle);
    if (layerSource.hasFeature(feature)) {
      // ol doesn't add features with same id, update existing
      var existing = layerSource.getFeatureById(id);
      existing.setGeometry(new olGeom.Point(coord));
      existing.setStyle(olStyle);
    } else {
      layerSource.addFeature(feature);
    }
    var data = this._featureToMarkerData(feature);
    var addEvent = Oskari.eventBuilder('AfterAddMarkerEvent')(data, id);
    this.getSandbox().notifyAll(addEvent);
  },
  _removeMarkerFromMap: function _removeMarkerFromMap(id) {
    var layerSource = this.getMarkersLayer().getSource();
    var feature = layerSource.getFeatureById(id);
    if (feature) {
      layerSource.removeFeature(feature);
    }
  },
  _featureToMarkerData: function _featureToMarkerData(feature) {
    var id = feature.getId();
    var coord = feature.getGeometry().getCoordinates();
    var styleData = this._styleData[id];
    return _objectSpread({
      id: id,
      x: coord[0],
      y: coord[1]
    }, styleData);
  },
  /**
   * Change map marker visibility.
   * @method  @public changeMapMarkerVisibility
   * @param  {Boolean} visible  visibility is marker visible or not.
   * @param  {String} id  optional marker id for marker to change it's visibility, all markers visibility changed if not given.
   */
  changeMapMarkerVisibility: function changeMapMarkerVisibility(visible, id) {
    var _this7 = this;
    var layerSource = this.getMarkersLayer().getSource();
    var update = function update(feature) {
      if (!feature) {
        // not found for requested id (invalid id or feature is visible/hidden already)
        return;
      }
      var fid = feature.getId();
      if (visible) {
        layerSource.addFeature(feature);
        delete _this7._hiddenMarkers[fid];
      } else {
        _this7._hiddenMarkers[fid] = feature;
        layerSource.removeFeature(feature);
      }
    };
    if (id) {
      var feature = visible ? this._hiddenMarkers[id] : layerSource.getFeatureById(id);
      update(feature);
    } else {
      var features = visible ? Object.values(this._hiddenMarkers) : layerSource.getFeatures();
      features.forEach(function (f) {
        return update(f);
      });
    }
  },
  /**
   * @method enableGfi
   * Enables/disables the gfi functionality
   * @param {Boolean} blnEnable true to enable, false to disable
   */
  enableGfi: function enableGfi(blnEnable) {
    var sandbox = this.getSandbox();
    var gfiReqBuilder = Oskari.requestBuilder('MapModulePlugin.GetFeatureInfoActivationRequest');
    var hiReqBuilder = Oskari.requestBuilder('WfsLayerPlugin.ActivateHighlightRequest');

    // enable or disable gfi requests
    if (gfiReqBuilder) {
      sandbox.request(this.getName(), gfiReqBuilder(blnEnable));
    }

    // enable or disable wfs highlight
    if (hiReqBuilder) {
      sandbox.request(this.getName(), hiReqBuilder(blnEnable));
    }
  },
  /**
   * @method setState
   * Set the bundle state
   * @param {Object} state bundle state as JSON
   */
  setState: function setState(state) {
    var _this8 = this;
    // Clear state
    this.getMarkersLayer().getSource().clear();
    this._hiddenMarkers = {};
    this._styleData = {};
    var _ref = state || {},
      markers = _ref.markers;
    if (markers) {
      markers.forEach(function (marker) {
        return _this8.addMapMarker(marker, null, true);
      });
    }
  },
  /**
   * Returns markers parameter for map link if any markers on map:
   * "&markers=shape|size|hexcolor|x_y|User input text___shape|size|hexcolor|x_y|input 2"
   * @return {String} link parameters
   */
  getStateParameters: function getStateParameters() {
    var _this$getState = this.getState(),
      markers = _this$getState.markers;
    return this.getMarkersString(markers);
  },
  getTransformedStateParameters: function getTransformedStateParameters(targetSrs) {
    var mapmodule = this.getMapModule();
    var currentSrs = mapmodule.getProjection();
    if (!targetSrs || targetSrs === currentSrs) {
      return this.getStateParameters();
    }
    var _this$getState2 = this.getState(),
      markers = _this$getState2.markers;
    var transformedMarkers;
    try {
      transformedMarkers = markers.map(function (marker) {
        var lonlat = mapmodule.transformCoordinates({
          lon: marker.x,
          lat: marker.y
        }, currentSrs, targetSrs);
        return _objectSpread(_objectSpread({}, marker), {}, {
          x: lonlat.lon,
          y: lonlat.lat
        });
      });
    } catch (err) {
      transformedMarkers = [];
    }
    ;
    return this.getMarkersString(transformedMarkers);
  },
  getMarkersString: function getMarkersString() {
    var markers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var FIELD = SEPARATORS.FIELD,
      MARKER = SEPARATORS.MARKER,
      COORD = SEPARATORS.COORD;
    var markerParams = markers.map(function (marker) {
      var shape = marker.shape,
        size = marker.size,
        color = marker.color,
        x = marker.x,
        y = marker.y,
        msg = marker.msg;
      var encodedMsg = encodeURIComponent(msg);
      return shape + FIELD + size + FIELD + color + FIELD + x + COORD + y + FIELD + encodedMsg;
    });
    if (markerParams.length > 0) {
      return '&markers=' + markerParams.join(MARKER);
    }
    return '';
  },
  /**
   * @method getState
   * Returns the bundle state
   * @return {Object} bundle state as JSON
   */
  getState: function getState() {
    var _this9 = this;
    if (!this.getMarkersLayer().getVisible()) {
      return {};
    }
    var markers = this.getMarkersLayer().getSource().getFeatures().map(function (feat) {
      return _this9._featureToMarkerData(feat);
    }).filter(function (markerData) {
      return !markerData.transient;
    });
    return {
      markers: markers
    };
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.AbstractMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});